/* eslint-disable @typescript-eslint/no-unused-vars */
import { addModel, createModel } from '@wmfe/mach-pro-store';
import { LxReportSourceModel, PanelItem } from '@/src/sub_packages/filter_bar/types';

export interface FilterBarState {
  // 筛选栏数据
  filterBarPanelData: any;
  // 筛选条是否处于展开状态
  filterBarPanelExpanded: boolean;
  // 筛选栏父视图引用
  filterBarPanelParentViewRef: any;

  popupViewWillShowIntercept?: (filterBar: any, clickPanelItem: PanelItem, handlerCompleted: (res: any) => void) => void;

  panelItemDidSelectedIntercept?: (filterBar: any, panelItem: PanelItem, selectedItem: any, handlerCompleted: (res: any) => void) => void;

  filterBarLxModel: LxReportSourceModel;
}

// 首页数据
export const filterBarModel = createModel()({

  state: {
    // 筛选栏数据
    filterBarPanelData: {},
    // 筛选框是否展开
    filterBarPanelExpanded: false,
    // 筛选栏父视图引用
    filterBarPanelParentViewRef: null,
    // 筛选栏展示拦截器
    popupViewWillShowIntercept: undefined,
    // 筛选栏面板选项点击拦截器
    panelItemDidSelectedIntercept: undefined,
    // 灵犀曝光 BID & CID 数据源
    filterBarLxModel: {},

  } as FilterBarState,

  reducers: {
    // 更新筛选栏数据
    updateFilterBarPanelData: (state, payload) => {
      const { filterBarPanelData } = state;
      return {
        ...state,
        filterBarPanelData: {
          ...filterBarPanelData,
          ...payload
        }
      };
    },

    // 回调筛选栏面板展开状态发生变更
    handleFilterBarPanelExpandedChanged: (state, payload) => ({
      ...state,
      filterPanelExpanded: payload
    }),
  },

  effects: (dispatch) => ({

    initialFilterBar: (payload, rootState) => {
      const { filterBarHandleModel, filterBarModel } = rootState;
      if (filterBarHandleModel) {
        const {
          filterBarPanelHandleParentViewRef,
          filterBarHandleLxModel,
          filterBarHandlePopupWillShowIntercept,
          filterBarHandlePanelItemDidSelectedIntercept,
          filterBarHandlePanelDataPayload
        } = filterBarHandleModel;
        // @ts-ignore
        filterBarModel.filterBarPanelParentViewRef = filterBarPanelHandleParentViewRef;
        // @ts-ignore
        filterBarModel.filterBarLxModel = filterBarHandleLxModel;
        // @ts-ignore
        filterBarModel.popupViewWillShowIntercept = filterBarHandlePopupWillShowIntercept;
        // @ts-ignore
        filterBarModel.panelItemDidSelectedIntercept = filterBarHandlePanelItemDidSelectedIntercept;
        // @ts-ignore
        filterBarModel.filterBarPanelData = filterBarHandlePanelDataPayload;
        if (filterBarHandlePanelDataPayload) {
          dispatch.filterBarModel.updateFilterBarPanelData(filterBarHandlePanelDataPayload);
        }
      }
    },

    // 回调筛选栏面板展开状态发生变更
    handleFilterBarPanelExpanded: (payload) => {
      const { handleFilterBarPanelExpandedChanged } = dispatch.filterBarModel;
      handleFilterBarPanelExpandedChanged(payload);
      dispatch.filterBarHandleModel?.didFilterBarPanelExpandedChanged(payload);
    },

    handleDidFilterBarDataSelectedChanged: (payload) => {
      dispatch.filterBarHandleModel?.didFilterBarDataSelectedChanged(payload);
    },

    updateFilterBarPanelParentViewRef: (payload, { filterBarModel }) => {
      const { ref } = payload;
      // @ts-ignore
      filterBarModel.filterBarPanelParentViewRef = ref;
    },

    updateFilterBarLxSourceModel: (payload, { filterBarModel }) => {
      const { lxModel } = payload;
      // @ts-ignore
      filterBarModel.filterBarLxModel = lxModel;
    },

    bindFilterBarPopupWillShowIntercept: (payload, { filterBarModel }) => {
      const { intercept } = payload;
      // @ts-ignore
      filterBarModel.popupViewWillShowIntercept = intercept;
    },

    bindFilterBarPanelItemDidSelectedIntercept: (payload, { filterBarModel }) => {
      const { intercept } = payload;
      // @ts-ignore
      filterBarModel.panelItemDidSelectedIntercept = intercept;
    }
  })
});

addModel('filterBarModel', filterBarModel);
